import { useBootstrap } from "@/features/bootstrap";

import { useTenantName } from "./use-tenant-name";

/**
 * Human-facing tenant name for display. The public, host-resolved bootstrap
 * endpoint is the authoritative source; while it's loading (or on error) we
 * fall back to the tenant slug decoded from the JWT so authenticated users
 * still see something reasonable. Null when neither is available yet, so
 * callers keep the existing `?? APP_NAME` fallback.
 */
export const useTenantDisplayName = (): string | null => {
  const { data } = useBootstrap();
  const tenantName = useTenantName();

  return data?.display_name ?? tenantName ?? null;
};
